<template>
    <div class="thanks__rate">
        <a
            href="#"
            class="btn btn--blue"
            @click.prevent="openModal()"
        >Valora tu Servicio</a>
    </div>

    <add-evaluation-form
        :url_store="url_store"
        :order_header_id="order_header_id ?? ''"
        :order_number="order_number ?? ''"
        @close-modal="closeModal()"
        @refresh-table=""
    ></add-evaluation-form>
</template>

<script>
import { inject, provide, ref } from 'vue';
import { customAlert } from '../../../general/js/utils/swalMessages';

export default {
    props: {
        url_store: {
            type: String,
            default: '',
        },
        url_profile: {
            type: String,
            default: '',
        },
        order_header_id: {
            type: [String, Number],
            default: '',
        },
        order_number: {
            type: String,
            default: '',
        }
    },
    setup (props) {
        const loading = inject("loading");

        const openModal = () => {
            $("#addEvaluationModal").modal("show");
        };

        const closeModal = () => {
            window.location.href = props.url_profile;
        }

        return {
            openModal,
            closeModal,
        }
    }
}
</script>
